export const integraciones = {
    text1: "Integrazioni.",
    text2: "Contatta gli sviluppatori per realizzare un'integrazione con il tuo",
    text3: "PMS",
    text4: "Contatta",
    text5: "Richiedi integrazione",
    text6: "Dati raccolti",
    text7: "Informazioni sul richiedente",
    text8: "Nome",
    text9: "Motivo della richiesta",
    text10: "Indica il motivo per cui hai bisogno dell'integrazione",
    text11: "Chiudi",
    text12: "Invia richiesta di integrazione",
    text13: "Registrata correttamente",
    text14: "Errore nella richiesta",
};